import "./object-define-property.js";
import { __exports as r } from "../../../_virtual/object-define-property.js";
var e = r.f,
  o = function o(r, _o, t) {
    t in r || e(r, t, {
      configurable: !0,
      get: function get() {
        return _o[t];
      },
      set: function set(r) {
        _o[t] = r;
      }
    });
  };
export { o as p };